<template>
  <modal id="renew-contract-modal"
         size="large"
         v-model="showModal"
         :title="$fieldTitle(buttonFirstTitle, 'renew_contract', true)"
         @submit="submitData"
         :scrollable="false"
         :loading="loading"
         :preloader="preloader">
    <form
        ref="form"
        @submit.prevent="submitData"
    >
      <app-form-group
          :label="$t('contract_start_date')"
          type="date"
          date-mode="date"
          v-model="formData.contract_start_date"
          :placeholder="$placeholder('contract_start_date')"
          :required="true"
          :error-message="$errorMessage(errors, 'contract_start_date')"
      />

      <app-form-group
          :label="$t('contract_end_date')"
          type="date"
          date-mode="date"
          v-model="formData.contract_end_date"
          :placeholder="$placeholder('contract_end_date')"
          :required="true"
          :error-message="$errorMessage(errors, 'contract_end_date')"
      />
    </form>
  </modal>
</template>

<script>
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import {
  formatDateTimeForServer,
  formatDateForServer,
  timezoneDate
} from "../../../../../common/Helper/Support/DateTimeHelper";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";
import {AUTO_EMPLOYEE_ID} from "../../../../Config/ApiUrl";

export default {
  name: "RenewContractModal",
  mixins: [ModalMixin, FormHelperMixins],
  props: {
    tableId: {},
    employee: {},
    specificId: {}
  },
  data() {
    return {
      formData: {},
      maxDate: timezoneDate()
    }
  },
  mounted() {
    this.$nextTick(()=>{
      if (window.innerHeight < 700){
        document.getElementsByClassName('modal-body')[0].style.height = '560px'
      }
    })
  },
  methods: {
    submitData() {
      this.loading = true;
      const formData = {...this.formData};
      formData.contract_start_date = formatDateForServer(this.formData.contract_start_date);
      formData.contract_end_date = formatDateForServer(this.formData.contract_end_date);

      this.submitFromFixin(
          'post',
          `${this.apiUrl.EMPLOYEES}/renew-contract`,
          formData
      );
    },
    afterSuccess({data}) {
      this.loading = false;
      $('#renew-contract-modal').modal('hide');
      this.$toastr.s('', data.message);
      if (this.tableId) {
        this.$hub.$emit(`reload-${this.tableId}`);
      } else {
        this.$emit('reload')
      }
    },
  },
  created() {
    if (!this.employee && !this.canUpdateContract && !this.specificId) {
      this.formData.employee_id = window.user.id
    }

    if (this.specificId) {
      this.formData.employee_id = this.specificId
      this.formData.contract_start_date = this.employee.contract_start_date
      this.formData.contract_end_date = this.employee.contract_end_date
    }
  },
  computed: {
    canUpdateContract() {
      if (this.specificId && this.$can('update_contract')) {
        return false;
      }
      if (this.employee && this.$can('update_contract')) {
        this.formData.employee_id = this.employee.id
        return false;
      }
      return this.$can('update_contract');
    },
    user_id() {
      return window.user.id;
    },
    buttonFirstTitle() {
      return this.$can('update_contract') ? '' : 'request';
    }
  }
}
</script>